import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Button from "web/components/Button";
import { BoxContainer, BoxContainerHeader, ActionBtn } from "web/pages/private/CommonPages/MyNetworks/myNetworksStyled";
import { ManageInvitationsWrapper, Box, InvitationsRow } from "web/pages/private/CommonPages/MyNetworks/Notification/ManageInvitationsStyled";

const Notification = ({ closeIconCallBack, notificationResponse, notificationPageDataInfo, fetchNotificationsCallback, pageLanguageContents }) => {
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const [page, setPage] = useState(1)
  const notificationWrapperRef = useRef(null);

  useEffect(() => {
    if (notificationPageDataInfo === 'pageResetToOne' && notificationWrapperRef.current) {
      notificationWrapperRef.current.scrollTop = 0;
    }
  }, [notificationPageDataInfo]);

  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (notificationPageDataInfo === 'endOfResults') {
      if (page !== 1) setPage(1);
    } else if (scrollHeight - scrollTop <= clientHeight * 1.2 && !loaderVisible) {
      if (notificationPageDataInfo === 'pageResetToOne') {
        setPage(2);
        fetchNotificationsCallback(2);
      } else {
        setPage(prevPage => prevPage + 1);
        fetchNotificationsCallback(page + 1);
      }
    }
  };

  return (
    <>
      <BoxContainer>
        <BoxContainerHeader>
          <h2>
            {pageLanguageContents?.Notifications[0]?.Notifications}
          </h2>
          <div className="clear-icon">
            <Button
              type="app-green-button"
              handleClick={() => {
                closeIconCallBack('clearAll')
              }}
            >
              Clear All
            </Button>
          </div>
        </BoxContainerHeader>
        <ManageInvitationsWrapper ref={notificationWrapperRef} onScroll={handleScroll}>
          {notificationResponse.map((items, index) => (
            <Box style={{ background: items.read ? '' : 'aliceblue' }} onClick={() => closeIconCallBack("Click", items.notificationId, items)}>
              <InvitationsRow>
                <div><h3>{items.notification}</h3></div>
              </InvitationsRow>
            </Box>
          ))}
        </ManageInvitationsWrapper>
        <ActionBtn>
          <button onClick={() => {
            closeIconCallBack()
          }}>
            {pageLanguageContents?.Notifications[1]?.Back}
          </button>
        </ActionBtn>
      </BoxContainer>
    </>
  );
}
export default Notification;